import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { GeofencingConfigService } from "../geofencing.config";

import { CurrentLocationModel } from "./current-location.model";

@Injectable({ providedIn: "root" })
export class CurrentLocationService {
	constructor(
		private config: GeofencingConfigService,
		private httpClient: CoreHttpClient
	) {}

	/**
	 * Returns id of provincia if the location is in Argentina. Otherwise returns null
	 * or undefined.
	 */
	getLocationId(lat: number, lon: number): Observable<CurrentLocationModel> {
		return this.httpClient.get<CurrentLocationModel>({
			url: this.config.getCurrentLocationEndpoint(),
			searchParams: { c: `${lat},${lon}` },
			withCredentials: false,
		});
	}
}
